/*=============================================== SelectPage ===============================================*/

import { useState } from "react"
import { Select } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import {
    commonProps,
    inputLabel,
    inputBackgroundColor,
    listDirection,
    inputVariants,
    iconBoxicon,
} from "data"

const SelectPage = () => {
    const selectItems: string[] = ["react", "javascript", "scss", "css", "html"]
    const [selected, setSelected] = useState<string>(selectItems[0])

    const items: ItemType[] = [
        {
            content: (
                <Select
                    label="Select"
                    selected={selected}
                    setSelected={setSelected}
                    items={selectItems}
                />
            ),
            code: 'const selectItems = ["react", "javascript", "scss", "css", "html"]\nconst [selected, setSelected] = useState(selectItems[0])\n\n<Select label="Select" selected={selected} setSelected={setSelected} items={selectItems} />',
            codeTs: 'const selectItems: string[] = ["react", "javascript", "scss", "css", "html"]\nconst [selected, setSelected] = useState<string>(selectItems[0])\n\n<Select label="Select" selected={selected} setSelected={setSelected} items={selectItems} />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "selected",
            type: "string",
            required: true,
        },
        {
            subtitle: "setSelected",
            type: "function",
            required: true,
        },
        {
            subtitle: "items",
            type: "array of strings",
        },
        inputBackgroundColor(),
        listDirection(),
        inputVariants(),
        {
            subtitle: "iconCaret",
            intro: commonProps.addIconCapital,
            type: "string",
            default: iconBoxicon("caret-down"),
        },
        ...inputLabel(),
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default SelectPage
